import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'spk-tab-panes',
  templateUrl: './spk-tab-panes.component.html',
  styleUrls: ['./spk-tab-panes.component.scss']
})
export class SpkTabPanesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/framework/spk/layouts/tabs/spk-tab-panes/spk-tab-panes.component.ts